import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { getSize } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { usePillsInputContext } from "./auth-service-tools384.js";
import { PillGroupProvider } from "./auth-service-tools385.js";
import classes from "./auth-service-tools387.js";
const defaultProps = {};
const varsResolver = createVarsResolver((_, _ref, _ref2) => {
  let {
    gap
  } = _ref;
  let {
    size
  } = _ref2;
  return {
    group: {
      "--pg-gap": gap !== void 0 ? getSize(gap) : getSize(size, "pg-gap")
    }
  };
});
const PillGroup = factory((_props, ref) => {
  const props = useProps("PillGroup", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    size,
    disabled,
    ...others
  } = props;
  const pillsInputCtx = usePillsInputContext();

  const _size = (pillsInputCtx == null ? void 0 : pillsInputCtx.size) || size || void 0;

  const getStyles = useStyles({
    name: "PillGroup",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    stylesCtx: {
      size: _size
    },
    rootSelector: "group"
  });
  return /* @__PURE__ */jsxRuntimeExports.jsx(PillGroupProvider, {
    value: {
      size: _size,
      disabled
    },
    children: /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      ref,
      size: _size,
      ...getStyles("group"),
      ...others
    })
  });
});
PillGroup.classes = classes;
PillGroup.displayName = "@mantine/core/PillGroup";
export { PillGroup };